/**
 * Webhook Helper for International Markets
 * 
 * Shared functions for sending Meta Pixel events via webhooks to n8n
 */

(function() {
  'use strict';
  
  // Configuration
  const WEBHOOK_BASE_URL = 'https://n8n-latest-1-js6i.onrender.com';
  const WEBHOOK_TOKEN = 'IB98yh97b08G97Vvyf9797V7Vex5s34';
  
  // Detect if this is an international market
  function isInternationalMarket() {
    if (window.MarketConfig && 
        typeof window.MarketConfig.isInternationalMarket === 'function') {
      return window.MarketConfig.isInternationalMarket();
    }
    
    if (window.shopifyLocale && window.shopifyLocale.code) {
      // Any language on a known market counts, so match the market suffix.
      const INTERNATIONAL_MARKET_LOCALE = /^[a-z]{2}-(?:ae|sa|gb|sg|us|eu|ca|au)$/;
      return INTERNATIONAL_MARKET_LOCALE.test(window.shopifyLocale.code);
    }
    
    // Check pathname - handle both with and without trailing slash (en-* and ar-ae, ar-sa)
    const path = window.location.pathname.toLowerCase();
    const pathMatch = path.match(/^\/[a-z]{2}-(?:ae|sa|gb|sg|us|eu|ca|au)(?:\/|$)/);
    if (pathMatch) {
      return true;
    }
    
    // Also check if path contains international market segments anywhere
    return /\/(?:en-(?:ae|sa|gb|sg|us|eu|ca|au)|ar-(?:ae|sa))(?:\/|$)/.test(path);
  }
  
  // Only run on international markets
  if (!isInternationalMarket()) {
    return;
  }
  
  // Get market configuration
  function getMarketConfig() {
    // Use MarketConfig if available
    if (window.MarketConfig && typeof window.MarketConfig.detectMarket === 'function') {
      const marketInfo = window.MarketConfig.detectMarket();
      if (marketInfo && marketInfo.config) {
        return {
          currency: marketInfo.config.currency,
          market: marketInfo.config.market,
          catalogPrefix: marketInfo.config.catalogPrefix || 'uae_',
          locale: marketInfo.config.locale || marketInfo.key
        };
      }
    }
    
    // Fallback when MarketConfig is unavailable. Market subfolders are always
    // {language}-{market}, so resolve on the market suffix: a new language on
    // an existing market needs no change here.
    const path = window.location.pathname.toLowerCase();
    const MARKETS_BY_SUFFIX = {
      ae: { currency: 'AED', market: 'UAE' },
      sa: { currency: 'SAR', market: 'Saudi Arabia' },
      gb: { currency: 'GBP', market: 'UK' },
      sg: { currency: 'SGD', market: 'Singapore' },
      us: { currency: 'USD', market: 'USA' },
      eu: { currency: 'EUR', market: 'Europe' },
      ca: { currency: 'CAD', market: 'Canada' },
      au: { currency: 'AUD', market: 'Australia' }
    };
    const marketMatch = path.match(/(?:^|\/)([a-z]{2}-(ae|sa|gb|sg|us|eu|ca|au))(?:\/|$)/);
    if (marketMatch && MARKETS_BY_SUFFIX[marketMatch[2]]) {
      const hit = MARKETS_BY_SUFFIX[marketMatch[2]];
      return { currency: hit.currency, market: hit.market, catalogPrefix: 'uae_', locale: marketMatch[1] };
    }


    // Default to UAE
    return { currency: 'AED', market: 'UAE', catalogPrefix: 'uae_', locale: 'en-ae' };
  }
  
  // Generate event ID (Meta format: sh-{8hex}-{4hex}-{4hex}-{4hex}-{12hex})
  function generateEventId() {
    function generateHex(length) {
      return Array.from({length: length}, () => 
        Math.floor(Math.random() * 16).toString(16).toUpperCase()
      ).join('');
    }
    return 'sh-' + generateHex(8) + '-' + generateHex(4) + '-' + 
           generateHex(4) + '-' + generateHex(4) + '-' + generateHex(12);
  }
  
  // Cache cookies after first read (performance optimization)
  // BUT: Clear cache if cookie manager might have just created cookies
  let cachedFbp = null;
  let cachedFbc = null;
  let cookiesCached = false;
  let lastCookieCheckTime = 0;
  
  // Clear cookie cache (useful when cookies might have been created after initial read)
  function clearCookieCache() {
    cachedFbp = null;
    cachedFbc = null;
    cookiesCached = false;
    lastCookieCheckTime = 0;
  }
  
  // Get fbp cookie (Facebook Browser ID) - cached for performance
  function getFbpCookie() {
    // Re-read cookies if enough time has passed (in case cookie manager created them)
    // This handles the case where webhook helper loaded before cookie manager created cookies
    const now = Date.now();
    if (cookiesCached && (now - lastCookieCheckTime) < 100) {
      // Recently checked, use cache
      return cachedFbp;
    }
    
    try {
      const match = document.cookie.match(/(?:^|; )_fbp=([^;]+)/);
      if (match && match[1]) {
        cachedFbp = decodeURIComponent(match[1]);
      } else {
        cachedFbp = null;
      }
    } catch (e) {
      cachedFbp = null;
    }
    lastCookieCheckTime = now;
    cookiesCached = true;
    return cachedFbp;
  }
  
  // Get fbc cookie (Facebook Click ID) - with fallback to URL parameter
  function getFbcCookie() {
    // Always read fresh (don't use cache) to ensure we get the latest cookie value
    // The cache is cleared in sendWebhook() anyway
    
    try {
      const match = document.cookie.match(/(?:^|; )_fbc=([^;]+)/);
      if (match && match[1]) {
        const fbc = decodeURIComponent(match[1]);
        
        // Debug logging
        if (window.location.search.includes('debug_cookies=true')) {
          console.log('[Webhook Helper International] Found _fbc cookie:', fbc, 'Parts:', fbc.split('.').length);
        }
        
        // Validate format (should have at least 4 parts separated by dots)
        if (!fbc.endsWith('.fbclid') && fbc.split('.').length >= 4) {
          cachedFbc = fbc;
          lastCookieCheckTime = Date.now();
          cookiesCached = true;
          
          if (window.location.search.includes('debug_cookies=true')) {
            console.log('[Webhook Helper International] ✅ Using _fbc cookie:', fbc);
          }
          
          return cachedFbc;
        } else {
          if (window.location.search.includes('debug_cookies=true')) {
            console.warn('[Webhook Helper International] _fbc cookie format invalid:', fbc, 'Parts:', fbc.split('.').length, 'Ends with .fbclid:', fbc.endsWith('.fbclid'));
          }
        }
      } else {
        if (window.location.search.includes('debug_cookies=true')) {
          console.log('[Webhook Helper International] No _fbc cookie found in document.cookie');
        }
      }
    } catch (e) {
      if (window.location.search.includes('debug_cookies=true')) {
        console.error('[Webhook Helper International] Error reading _fbc cookie:', e);
      }
    }
    
    // If cookie doesn't exist or is invalid, check URL for fbclid as fallback
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const fbclid = urlParams.get('fbclid');
      
      if (fbclid) {
        if (window.location.search.includes('debug_cookies=true')) {
          console.log('[Webhook Helper International] fbclid found in URL, attempting to create/get _fbc cookie');
        }
        
        // Try to trigger cookie creation if cookie manager is available
        if (window.MetaPixelCookieManager && typeof window.MetaPixelCookieManager.createFbcCookie === 'function') {
          const fbcValue = window.MetaPixelCookieManager.createFbcCookie();
          if (fbcValue) {
            cachedFbc = fbcValue;
            lastCookieCheckTime = Date.now();
            cookiesCached = true;
            
            if (window.location.search.includes('debug_cookies=true')) {
              console.log('[Webhook Helper International] ✅ Got _fbc from cookie manager:', fbcValue);
            }
            
            return cachedFbc;
          }
        }
        
        // If cookie manager not available, construct fbc value manually.
        // creationTime is Unix time in MILLISECONDS (Meta spec); reuse first-observed ts if stored.
        // Format: fb.1.{creationTime}.{fbclid}
        let fbcCreationTime = null;
        try { fbcCreationTime = parseInt(sessionStorage.getItem('fbclid_ts'), 10) || null; } catch (e) {}
        if (!fbcCreationTime) fbcCreationTime = Date.now();
        const fbcValue = `fb.1.${fbcCreationTime}.${fbclid}`;
        cachedFbc = fbcValue;
        lastCookieCheckTime = Date.now();
        cookiesCached = true;
        
        if (window.location.search.includes('debug_cookies=true')) {
          console.log('[Webhook Helper International] ✅ Constructed _fbc from URL fbclid:', fbcValue);
        }
        
        return cachedFbc;
      }
    } catch (e) {
      if (window.location.search.includes('debug_cookies=true')) {
        console.error('[Webhook Helper International] Error reading fbclid from URL:', e);
      }
    }
    
    if (window.location.search.includes('debug_cookies=true')) {
      console.warn('[Webhook Helper International] ⚠️ Returning null for fbc - no cookie and no fbclid in URL');
    }
    
    cachedFbc = null;
    lastCookieCheckTime = Date.now();
    cookiesCached = true;
    return cachedFbc;
  }
  
  // Convert price from INR cents to market currency
  function convertToMarketCurrency(priceInCents) {
    // Use MarketConfig if available (preferred method)
    if (window.MarketConfig && typeof window.MarketConfig.convertPrice === 'function') {
      return window.MarketConfig.convertPrice(priceInCents);
    }
    
    // Fallback to manual conversion
    const marketConfig = getMarketConfig();
    
    // Fallback rates (should match MarketConfig rates)
    const rates = {
      'AED': 0.04,
      'USD': 0.012,
      'GBP': 0.0095,
      'SAR': 0.045,
      'SGD': 0.016,
      'EUR': 0.011
    };
    
    const rate = rates[marketConfig.currency] || 0.04;
    const inrAmount = priceInCents / 100;
    return inrAmount * rate;
  }
  
  // Round up price to nearest whole number
  function roundUpPrice(price) {
    return Math.ceil(price);
  }
  
  // Prefix content IDs with catalog prefix
  function prefixContentIds(ids) {
    // Use MarketConfig if available (preferred method)
    if (window.MarketConfig && typeof window.MarketConfig.prefixContentIds === 'function') {
      return window.MarketConfig.prefixContentIds(ids);
    }
    
    // Fallback to manual prefixing
    const marketConfig = getMarketConfig();
    const prefix = marketConfig.catalogPrefix || 'uae_';
    
    return ids.map(id => {
      const idStr = id.toString();
      if (idStr.startsWith(prefix)) {
        return idStr; // Already prefixed
      }
      return prefix + idStr;
    });
  }
  
  // Detect bots/crawlers. Googlebot renders JS, so without this it fires pixel events and
  // pollutes the Meta dataset (and wastes n8n executions).
  function isLikelyBot() {
    try {
      if (navigator.webdriver === true) return true;
      var ua = (navigator.userAgent || '').toLowerCase();
      if (!ua) return true;
      return /bot|crawl|spider|slurp|googlebot|adsbot|mediapartners|google-inspectiontool|bingbot|bingpreview|duckduckbot|baiduspider|yandex|petalbot|semrush|ahrefs|facebookexternalhit|headlesschrome|lighthouse|pagespeed|pingdom|uptimerobot/i.test(ua);
    } catch (e) {
      return false;
    }
  }

  // Send webhook to n8n
  function sendWebhook(eventName, payload) {
    // Skip bots/crawlers so they don't pollute Meta events.
    if (isLikelyBot()) {
      if (window.location.search.includes('debug_webhook=true')) {
        console.log(`[Webhook Helper International] Skipped ${eventName} — bot/crawler detected`);
      }
      return;
    }

    const webhookUrl = `${WEBHOOK_BASE_URL}/webhook/meta-pixel/${eventName.toLowerCase()}`;
    
    // Clear cookie cache before reading (in case cookie manager just created cookies)
    // This ensures we get fresh cookie values
    clearCookieCache();
    
    // Debug: Log all cookies
    if (window.location.search.includes('debug_cookies=true')) {
      console.log('[Webhook Helper International] All cookies:', document.cookie);
      console.log('[Webhook Helper International] Reading fbp and fbc for webhook...');
    }
    
    // Read cookies fresh
    const fbpValue = getFbpCookie();
    const fbcValue = getFbcCookie();
    
    if (window.location.search.includes('debug_cookies=true')) {
      console.log('[Webhook Helper International] Cookie values for webhook:', { fbp: fbpValue, fbc: fbcValue });
    }
    
    // event_time is the time the event occurred (Unix SECONDS). The fbc creation time is the
    // (earlier) click time, so event_time is naturally >= it — no adjustment needed. Do NOT mix
    // in fbcCreationTs here: fbc now stores creationTime in MILLISECONDS and mixing units would
    // corrupt event_time.
    const eventTime = Math.floor(Date.now() / 1000);
    
    // Add common fields
    const fullPayload = {
      ...payload,
      event_name: eventName,
      event_time: eventTime,
      event_id: payload.event_id || generateEventId(),
      event_source_url: window.location.href,
      action_source: 'website',
      fbp: fbpValue,
      fbc: fbcValue,
      user_data: {
        client_user_agent: navigator.userAgent
      }
    };
    
    // Send webhook (non-blocking)
    fetch(webhookUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Webhook-Token': WEBHOOK_TOKEN
      },
      body: JSON.stringify(fullPayload),
      keepalive: true // Ensure delivery even if page unloads
    })
    .catch(err => {
      // Silent failure - don't block user experience
      if (window.location.search.includes('debug_webhook=true')) {
        console.error(`[Webhook Helper] Failed to send ${eventName}:`, err);
      }
    });
  }
  
  // Expose helper functions
  window.WebhookHelper = {
    isInternationalMarket: isInternationalMarket,
    getMarketConfig: getMarketConfig,
    generateEventId: generateEventId,
    getFbpCookie: getFbpCookie,
    getFbcCookie: getFbcCookie,
    clearCookieCache: clearCookieCache,
    convertToMarketCurrency: convertToMarketCurrency,
    roundUpPrice: roundUpPrice,
    prefixContentIds: prefixContentIds,
    sendWebhook: sendWebhook
  };
  
})();

